import User from '../models/User';

export const isTargetGroupInSite = (userRedux: User | null, targetGroup?: { id: string; name: string } | null) => {
  if (targetGroup) {
    const targetGrousInSite = userRedux?.sites?.map(site => site.targetGroups);
    return targetGrousInSite?.flat().some(tg => tg?.id === targetGroup.id);
  } else {
    return false;
  }
};
